export default "__VITE_ASSET__C1zyz9WN__"